import React from 'react';
const ErrorPopupLayout = ({ children }) => {
    return (React.createElement("div", { className: "hg-modal__warning" },
        React.createElement("div", { className: "hg-modal__warning--inner" }, children)));
};
export default ErrorPopupLayout;
